import { withStyles } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiTextareaAutosize from '@material-ui/core/TextareaAutosize';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import * as API from 'api';
import { useMutation } from 'react-query';
import MuiTextField from '@material-ui/core/TextField';
import MuiEditIcon from '@mui/icons-material/Edit';

const QueryLibrary = API.QueryLibrary();

const styles = theme => ({
  dialogFooter: {
    padding: theme.spacing(1.5),
  },
  title: {
    width: '100%',
    marginBottom: '10px',
  },
  textArea: {
    width: '100%',
    minHeight: '100px',
  },
  actionButton: {
    borderRadius: 100,
    minWidth: 32,
    minHeight: 32,
    padding: 0,
  },
});

const EditQuery = ({ refetch, id, title, prompt, ...props }) => {
  const { classes } = props;
  const [open, setOpen] = useState(false);
  const formMethods = useForm({
    defaultValues: {
      title,
      prompt,
    },
  });

  const editQuery = useMutation(({ id, title, prompt }) => QueryLibrary.editQueryLibraryPrompt({ id, title, prompt }), {
    onSuccess: () => {
      formMethods.reset();
      handleClose();
      refetch();
    },
    onError: error => {
      alert(error.data?.message || 'Unknown Error');
      editQuery.reset();
    },
  });

  function handleClick() {
    setOpen(true);
  }
  function handleClose() {
    setOpen(false);
  }
  function handleSubmit(data) {
    const { title, prompt } = data;
    editQuery.mutate({ id, title, prompt });
  }

  return (
    <>
      <MuiButton variant="text" color="primary" className={classes.actionButton} onClick={handleClick}>
        <MuiEditIcon />
      </MuiButton>
      <MuiDialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <MuiDialogTitle id="form-dialog-title">Edit query</MuiDialogTitle>
        <form onSubmit={formMethods.handleSubmit(handleSubmit)}>
          <MuiDialogContent>
            <MuiTextField
              className={classes.title}
              label="Title"
              name="title"
              value={formMethods.watch('title')}
              onChange={e => formMethods.setValue('title', e.target.value)}
              {...formMethods.register('title')}
            />
            <MuiTextareaAutosize
              className={classes.textArea}
              label="Query"
              name="prompt"
              value={formMethods.watch('prompt')}
              onChange={e => formMethods.setValue('prompt', e.target.value)}
              {...formMethods.register('prompt')}
            />
          </MuiDialogContent>
          <MuiDialogActions className={classes.dialogFooter}>
            <MuiButton variant="contained" onClick={handleClose}>
              Cancel
            </MuiButton>
            <MuiButton
              variant="contained"
              color="primary"
              type="submit"
              disabled={!formMethods.watch('prompt') || !formMethods.watch('title') || editQuery.isLoading}>
              {editQuery.isLoading ? 'Editing...' : 'Edit query'}
            </MuiButton>
          </MuiDialogActions>
        </form>
      </MuiDialog>
    </>
  );
};

export default withStyles(styles)(EditQuery);
